export const btnGold =
  "inline-flex items-center gap-3 border border-[#D4AF37]/70 bg-transparent px-8 py-3.5 text-xs uppercase tracking-[0.25em] text-[#D4AF37] transition-colors duration-300 hover:bg-[#D4AF37] hover:text-black";

export const btnGhost =
  "inline-flex items-center gap-3 border border-white/25 bg-transparent px-8 py-3.5 text-xs uppercase tracking-[0.25em] text-white/80 transition-colors duration-300 hover:border-white hover:text-white";

export const btnGoldDisabled =
  "inline-flex items-center gap-3 border border-white/15 px-8 py-3.5 text-xs uppercase tracking-[0.25em] text-white/30 cursor-not-allowed";

export const eyebrow = "text-xs uppercase tracking-[0.35em] text-[#D4AF37]";
